import Vue from "vue";

import VueMultiselect from "vue-multiselect";
VueMultiselect.compatConfig = { MODE: 3 };

import "vue-multiselect/dist/vue-multiselect.min.css";
// import "vue-multiselect/dist/vue-multiselect.css";

Vue.component("VueMultiselect", VueMultiselect);
